import { useSelector } from 'react-redux';

import { CommonAppState } from '../CommonAppState';

import { SuperAction } from './constants';
import { someActionIsLoadingSelector } from './selectors';

export const useSomeActionIsLoadingSelector = (actions: SuperAction[]) => {
  return useSelector((state: CommonAppState) =>
    someActionIsLoadingSelector(state, actions),
  );
};
